const LOWER = "abcdefghijklmnopqrstuvwxyz";
const UPPER = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const NUM   = "0123456789";
const SPEC  = "!@#$%^&*()-_=+[]{};:,.<>?/";

function randIndex(max) {
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    const buf = new Uint32Array(1);
    crypto.getRandomValues(buf);
    return buf[0] % max;
  }
  // Fallback (non-crypto) – should rarely be used in browsers
  return Math.floor(Math.random() * max);
}

function pick(set) {
  return set[randIndex(set.length)];
}

function shuffle(str) {
  const arr = str.split("");
  for (let i = arr.length - 1; i > 0; i--) {
    const j = randIndex(i + 1);
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr.join("");
}

export function generatePassword(length = 12) {
  const minLen = Math.max(8, length);

  const required = [
    pick(LOWER),
    pick(UPPER),
    pick(NUM),
    pick(SPEC),
  ];

  const ALL = LOWER + UPPER + NUM + SPEC;
  let remaining = "";
  for (let i = required.length; i < minLen; i++) {
    remaining += pick(ALL);
  }

  return shuffle(required.join("") + remaining);
}
const escapedSpec = SPEC.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
const specialCharacterRegex = new RegExp("[" + escapedSpec + "]");
export function isStrongPassword(pw) {
  return (
    pw.length >= 8 &&
    /[a-z]/.test(pw) &&
    /[A-Z]/.test(pw) &&
    /\d/.test(pw) &&
    specialCharacterRegex.test(pw)
  );
}